/* RESPONSIBLE TEAM: team-inbox */

enum Theme {
  Light = 'light',
  Dark = 'dark',
  System = 'system',
}

export default Theme;
